import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ESignatureComponent } from './eSignature.component';
import { EDashboardComponent } from './e-dashboard/e-dashboard.component';
import { StepOneComponent } from './step-one/step-one.component';
import { StepTwoComponent } from './step-two/step-two.component';
import { StepThreeComponent } from './step-three/step-three.component';
import { StepFourComponent } from './step-four/step-four.component';
import { HtmlCanvasComponent } from './html-canvas/html-canvas.component';
import { ShowReportComponent } from './show-report/show-report.component';
import { InboxComponent } from './e-dashboard/inbox/inbox.component';
import { SentComponent } from './e-dashboard/sent/sent.component';
import { DraftComponent } from './e-dashboard/draft/draft.component';
import { FavouriteComponent } from './e-dashboard/favourite/favourite.component';
import { TrashComponent } from './e-dashboard/trash/trash.component';
import { StepOneTabularComponent } from './tabularForm/step-one-tabular/step-one-tabular.component';
import { StepTwoTabularComponent } from './tabularForm/step-two-tabular/step-two-tabular.component';
import { HTMLFormComponent } from './HTMLForm/HTMLForm.component';

const routes: Routes = [
  {
    path: '',
    component: ESignatureComponent,
    children: [
      {
        path: '',
        component: EDashboardComponent
      },
      {
        path: 'first',
        component: StepOneComponent
      },
      {
        path: 'second',
        component: StepTwoComponent
      },
      {
        path: 'third',
        component: StepThreeComponent
      },
      {
        path: 'four',
        component: StepFourComponent
      },
      {
        path: 'htmlcanvas',
        component: HtmlCanvasComponent
      },
      {
        path: 'htmlform',
        component: HTMLFormComponent
      },
      {
        path: 'report',
        component: ShowReportComponent
      },
      {
        path: 'inbox',
        component: InboxComponent
      },
      {
        path: 'sent',
        component: SentComponent
      },      
      {
        path: 'draft',
        component: DraftComponent
      },
      {
        path: 'trash',
        component: TrashComponent
      },
      {
        path: 'favourite',
        component: FavouriteComponent
      },
      {
        path: 'firsttabular',
        component: StepOneTabularComponent
      },
      {
        path: 'secondtabular',
        component: StepTwoTabularComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class eSignatureRoutingModule { }
